module.exports = __webpack_public_path__ + "static/media/DNGNGEN.f4306527.svg";